import React from "react";

const ContactUs = () => {
  return (
    <div className="w-full bg-[#1A1A1A] py-16 px-6 md:px-20">
      <h1 className="pb-10 text-2xl md:text-[33px] text-white font-medium text-center md:text-left">
        Contact <span className="text-[#FEC961]">Us</span>
      </h1>
      <div className="flex flex-col-reverse md:flex-row items-center md:items-start">
      <div className="w-full md:w-3/5 flex items-center p-6 md:px-20 bg-[#00000040] rounded-lg h-auto md:h-[400px] lg:h-[500px]">
          <div className="text-base text-white font-medium w-full">
            <div className="pb-8">
              <h2 className="text-[#FF6C2F] text-center md:text-left">Connect with us</h2>
              <div className="flex justify-center md:justify-start space-x-4 pt-6">
                <a
                  href="https://www.instagram.com/artistaloud/?hl=en"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src="assets/instagram.png" alt="Instagram Logo" className="w-6 h-6 md:w-auto md:h-auto"/>
                </a>
                <a
                  href="https://www.facebook.com/artistaloud/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src="assets/facebook.png" alt="Facebook Logo" className="w-6 h-6 md:w-auto md:h-auto"/>
                </a>
                <a
                  href="https://www.youtube.com/user/ArtistAloud"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src="assets/youtube.png" alt="YouTube Logo" className="w-6 h-6 md:w-auto md:h-auto"/>
                </a>
                <a
                  href="https://x.com/AloudArtist"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src="assets/Vector.svg" alt="Twitter Logo" className="w-6 h-6 md:w-auto md:h-auto"/>
                </a>
              </div>
            </div>
            <p className="text-[#FF6C2F] text-center md:text-left">Contact Info</p>
            <p className="pt-3 font-normal text-center md:text-left">
              Artist Aloud
              <br />
              <a className="underline" href="mailto:artistaloud@hungama.com">artistaloud@hungama.com</a>
            </p>
          </div>
        </div>
        <div className="w-full md:w-2/5 h-64 md:h-[500px] relative md:mt-0">
          <img
            src="assets/contactUs-bg.png"
            alt=""
            className="w-full h-full object-cover"
          />
          <div className="absolute top-0 left-0 right-0 bottom-0 flex justify-center items-center">
            <img
              src="assets/logo-img.png"
              alt="Logo"
              className="w-2/3 h-2/3 object-contain"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
